/**
 * インフルエンサー負担率の許可値
 *
 * この定数配列から型が自動生成されるため、
 * 値の追加・削除はここで行い、他の箇所はこの定数を参照すること
 */
export const BURDEN_RATE_VALUES = [0, 10, 20, 30] as const

/**
 * インフルエンサー負担率の型
 *
 * BURDEN_RATE_VALUESから自動生成される厳密な型
 */
export type BurdenRate = (typeof BURDEN_RATE_VALUES)[number]

/**
 * インフルエンサー負担率の型ガード
 */
export const isBurdenRate = (value: unknown): value is BurdenRate => {
  return typeof value === 'number' && BURDEN_RATE_VALUES.includes(value as BurdenRate)
}

/**
 * number | null | undefined を BurdenRate に安全に変換するヘルパー
 * 不正な値の場合は0にフォールバック
 */
export const toBurdenRate = (value: number | null | undefined): BurdenRate => {
  if (isBurdenRate(value)) {
    return value
  }
  return 0
}
